import { useState } from 'react';
import Axios from '../utils/axiosInstance';

const useCollection = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const search = async (collectionName, filters = {}, sortOrder = 'featured') => {
    setLoading(true);
    setError(null);
    const filterParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (key !== 'start_price' && key !== 'end_price') {
        filterParams.append('attribute', value);
      } else {
        filterParams.append(key, value);
      }
    });
    
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}collection/collections/?collection=${collectionName}&sort=${sortOrder}&${filterParams.toString()}`;

    try {
      const response = await Axios.get(apiUrl);
      if (response.data) {
        return response.data;
      } else {
        throw new Error('No data found');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { search, loading, error };
};

export default useCollection;
